import React from 'react';
import RegistrationForm from '../components/registrationForm';

import { AuthStdFooter } from "../utils/auth-std-footer";
export default function RegistrationPage() {
  const registrationPage = () => {
    return (
      <div style={{ marginBottom: "70px" }}>
        <RegistrationForm />
      </div>
    );
  }
  return (<>{registrationPage()}</>)
}

